<template>
    <div class="user-list">
        <user-card
            v-for="user in users"
            :key="`${vuexState}${user.email}`"
            :user="user"
            v-bind="$props"
        >
        </user-card>
    </div>
</template>

<script>
    import UserCard from "./UserCard";
    import userListMixin from "../../../mixins/userListMixin";
    import {mapState} from "vuex";

    export default {
        mixins: [userListMixin],
        components: {UserCard},
        computed: {
            ...mapState('userManagement', {
                users(state) {
                    return state[this.vuexState];
                },
            })
        },
    };
</script>

<styles lang="scss" scoped>
    .user-list {
        display: flex;
        flex-wrap: wrap;

        .user-block {
            flex: 0 48%;
        }
    }
</styles>
